export default __webpack_public_path__ + "static/media/players.8929074a.svg";